import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import states from './states.json';

class UsStates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statesData: states
    };
    const { isRequired, updateFieldErrors, answer } = this.props;
    this.focused = false;
      if (isRequired && (answer === '' || answer === undefined || answer === null)) {
        updateFieldErrors(['pulpoforms.errors.not_blank']);
      }
  }

  handleAnswerChanged(value, fieldId) {
    const {
      handleValueChange, handleFieldErrorChanged, isRequired, updateFieldErrors
    } = this.props;
    handleValueChange(value, fieldId);
    let updatedErrors = [];
    if (!value) {
      handleFieldErrorChanged(fieldId, isRequired);
      updatedErrors = [...updatedErrors, 'pulpoforms.errors.not_blank'];
    } else {
      handleFieldErrorChanged(fieldId, false);
    }
    updateFieldErrors(updatedErrors);
  }

  render() {
    const { fieldId, answer, customField, full_width } = this.props;
    const { statesData } = this.state;
    return (
      <div style={{ width: (!full_width && customField)? '447px' : '' }}>
              <Select
                options={statesData}
                value={answer}
                onChange={e => this.handleAnswerChanged(e, fieldId)}
              />
      </div>
    );
  }
}

UsStates.defaultProps = {
  answer: undefined
};

UsStates.propTypes = {
  handleValueChange: PropTypes.func.isRequired,
  fieldId: PropTypes.string.isRequired,
  answer: PropTypes.string,
  isRequired: PropTypes.bool.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  updateFieldErrors: PropTypes.func.isRequired
};

export default UsStates;
